<div class="row">
  <div class="col-1">
    <app-back-button></app-back-button>
  </div>
  <div class="col">
    <h2 class="h2-responsive text-center">New Assessment</h2>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="card card-cascade narrower">
        <div class="view gradient-card-header primary-gradient white-text">
            <h3 class='h3-responsive text-center'>{{assessment.name}}</h3>
        </div>
        <div class="card-body">
          <form >
            <div class="form-group">
              <label for="name">Unique Identifier:</label>
              <input class="form-control" type="text" id="uid" name="uid" [(ngModel)]="assessment.uid" />
            </div>
            <div class="form-group">
              <label for="name">Name:</label>
              <input class="form-control" type="text" id="name" name="name" [(ngModel)]="assessment.name" />
            </div>
            <div class="form-group">
                <label for="instructions">Instructions:</label>
                <textarea class="form-control" id="instructions" name="instructions" [(ngModel)]="assessment.instructions"></textarea>
            </div> 
            <div class="form-group">
                <label for="description">Description:</label>
                <textarea class="form-control" id="description" name="description" [(ngModel)]="assessment.description"></textarea>
            </div>
            
            <div class="form-group">
                <label for="creator">Creator:</label>
                <input class="form-control" type="text" id="creator" name="creator" [(ngModel)]="assessment.creator" />
            </div>
            <div class="form-group">
                <label for="creator">Creator Url:</label>
                <input class="form-control" type="text" id="creatorUrl" name="creatorUrl" [(ngModel)]="assessment.creatorUrl" />
            </div>
            <div class="form-group">
              <label for="resourcesURL">Resources URL:</label>
              <input class="form-control" type="text" id="resourcesURL" name="resourcesURL" [(ngModel)]="assessment.resourcesURL" />
            </div>
            <input class="btn btn-primary" type="submit" (click)="save()" value="Save" />
        </form>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/assessment-new/assessment-new.component.html